import * as React from "react";
import { Button } from "semantic-ui-react";

import { AddBillingTaskModal } from "./AddBillingTaskModal";

type Props = {
    customerId: string;
    ohCaseId: string;
}

export const AddBillingTask: React.FunctionComponent<Props> = (props) => {

    const [open, setOpen] = React.useState(false);

    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);

    return (
        <>
            <AddBillingTaskModal
                open={open}
                onClose={onClose}
                customerId={props.customerId}
                ohCaseId={props.ohCaseId}
            />
            <Button
                icon="add"
                content="Add Billing Task"
                onClick={onOpen}
            />
        </>
    );
};
